'use client'

import { createContext, PropsWithChildren, useContext } from 'react'

interface AccountDashboardFeatureState {
    messageCenterEnabled: boolean
}

const defaultState: AccountDashboardFeatureState = {
    messageCenterEnabled: false,
}

const AccountDashboardFeatureContext = createContext<AccountDashboardFeatureState>(defaultState)

export function AccountDashboardFeatureProvider({
    messageCenterEnabled = false,
    children,
}: PropsWithChildren<{ messageCenterEnabled?: boolean }>) {
    return (
        <AccountDashboardFeatureContext.Provider value={{ messageCenterEnabled }}>
            {children}
        </AccountDashboardFeatureContext.Provider>
    )
}

/** Server-evaluated `message-center` flag for the authenticated patient. */
export function useMessageCenterFeatureEnabled() {
    return useContext(AccountDashboardFeatureContext).messageCenterEnabled
}
